// import waypoints from node_modules
import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/sticky';

(function($) {
    // Anchor bar script =================================================================================================
    if ($('.anchor-nav').length) {
        const sticky = new Waypoint.Sticky({
            element: $('.anchor-nav'),
            wrapper: '<div class="anchor-sticky-wrapper" />'
        })

        const footerAnchorWaypoint = new Waypoint({
            element: $('footer'),
            handler: function(direction) {
                $('.anchor-nav').toggleClass('stuck');
            }, 
            offset: function() {
                return $('.anchor-nav').outerHeight()
            }
        });

        setAnchorNavStyle();

        $('.anchor-nav-item-link').on('click', function (e) {
            e.preventDefault();
            $('.anchor-nav-item-link.active').removeClass('active');
            $(this).addClass('active');
            //get active section id
            let active_section = $(this).attr('href');

            // only do this if it's an anchor link
            if ($(active_section).length && active_section.match("^#")) {
                $('html, body').animate({
                    //and scroll to the section
                    scrollTop: ( $(active_section).offset().top - ( $('.anchor-nav-wrapper').outerHeight() + 30 ) )
                }, 1000);
            }
        });

        $('.anchor-nav-item-link').first().addClass('active');

        $(document).on('scroll', function() {
            //get document scroll position
            let current_position = $(document).scrollTop();
            let nav_height = $('.anchor-nav-wrapper').outerHeight();

            setAnchorNavStyle();
        
            //check active section
            $('.anchor-nav-item-link').each(function(i) {
                let section = $(this).attr('href');

                if ($(section).length && section.match("^#")) {
                    let top    = $(section).offset().top;
                    let bottom = top + $(section).outerHeight();

                    if (current_position >= (top - (nav_height + 40)) && current_position <= bottom) {
                        if (!$(this).hasClass('active')) {
                            $(".anchor-nav-item-link.active").removeClass('active');
                            $(this).addClass('active');

                            if (window.location.hash !== section.replace('#', '')) {
                                const offsetInElement = $(this).parent().offset().left + $(this).parent().parent().scrollLeft() - $(this).parent().offsetParent().offset().left;
                                const offsetLeft = offsetInElement - 15;
                                
                                $('.anchor-nav-list').stop();
                                $('.anchor-nav-list').animate({scrollLeft: offsetLeft}, 200);

                                if (history.pushState) {
                                    history.pushState(null, null, section);
                                } else {
                                    location.hash = section;
                                }
                            }
                        }
                    }
                }
            });
        });
    }


    // make the anchor nav smaller if it has multiple rows
    function setAnchorNavStyle() {
        if( $('.anchor-nav-wrapper' ).outerHeight() > 70) {
            $('.anchor-nav').addClass('smaller');
        } else {
            $('.anchor-nav').removeClass('smaller');
        }
    }
})(jQuery);
